import {
  AlertCircle as AlertCircleIcon,
  BarChart as BarChartIcon,
  Lock as LockIcon,
  Settings as SettingsIcon,
  ShoppingBag as ShoppingBagIcon,
  User as UserIcon,
  UserPlus as UserPlusIcon,
  Users as UsersIcon,
  Code as CodeIcon,
  CreditCard,
  List as ListIcon
} from 'react-feather';

export default [
  {
    href: '/dashboard',
    icon: BarChartIcon,
    title: 'Dashboard',
    id: 'dashboard'
    // super: '0'
  },
  {
    href: '/topup',
    icon: CreditCard,
    title: 'Topup',
    id: 'topup'
    // super: '0'
  },
  // {
  //   href: '/key-manager',
  //   icon: LockIcon,
  //   title: 'Key Manager',
  //   super: 1,
  //   isAdmin: false,
  //   id: 'key_manager'
  // },
  {
    href: '/routes-manager',
    icon: CodeIcon,
    title: 'Routes Manager',
    id: 'route'
    // super: '0'
  },
  {
    href: '/route-categories',
    icon: CodeIcon,
    title: 'Route Categories',
    id: 'route'
    // super: '0'
  },
  {
    href: '/request-history',
    icon: CodeIcon,
    title: 'Request History',
    id: 'gw_request_history'
    // super: '0'
  },
  {
    href: '/api-access-key',
    icon: CodeIcon,
    title: 'API Access Key Manager',
    id: 'api_access_key'
    // super: '0'
  },
  {
    href: '/logs',
    icon: ListIcon,
    title: 'Access Logs',
    id: 'activity_log'
    // super: '0'
  },
  {
    href: '/reports',
    icon: ListIcon,
    title: 'Reports',
    id: 'report'
    // super: '0'
  },
  {
    href: '/profile',
    icon: UserIcon,
    title: 'Staff Manager',
    id: 'profile'
    // super: '0'
  },
  {
    href: '/client-manager',
    icon: UserIcon,
    title: 'Client Manager',
    super: '0',
    isAdmin: true,
    id: 'admin'
  }
];
